import Vue from 'vue'
import Router from 'vue-router'
import axios from 'axios'
import { Message }  from 'element-ui'
Vue.use(Router)

// 解决路由跳转报错问题
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
const originalReplace = Router.prototype.replace
Router.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => err)
}
var router = new Router({
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return {
        x: 0,
        y: 0
      }
    }
  },

  routes: [
    {
      path: "/webView",  // 富文本页面
      name: "webView",
      component: resolve => require(['../view/webView.vue'], resolve),
    },
    {
      path: "/login",  // 登录页
      name: "login",
      component: resolve => require(['../view/login.vue'], resolve),
    },
    {
      path: "/subject",  // 专题首页
      name: "subject",
      component: resolve => require(['../view/subject.vue'], resolve),
    },
    {
      path: "/subjectDetail",  // 专题详情页
      name: "subjectDetail",
      component: resolve => require(['../view/subjectDetail.vue'], resolve),
    },
    {
      path: "/priseApply",  // 登录页
      name: "priseApply",
      component: resolve => require(['../view/priseApply.vue'], resolve),
    },
    {
      path: "/mainPerson",    // 个人端页面
      name: "mainPerson",
      component: resolve => require(['../view/mainPerson.vue'], resolve),
      children: [
        {
          path: "index",  // 首页
          name: "index",
          component: resolve => require(['../view/personView/index.vue'], resolve),
        },
        {
          path: "message",   // 消息页
          name: "message",
          component: resolve => require(['../view/personView/message/message.vue'], resolve),
        },
        {
          path: "company",    // 公司列表
          name: "company",
          component: resolve => require(['../view/personView/company.vue'], resolve),
        },
        {
          path: "companyDetail",    // 公司详情页
          name: "companyDetail",
          component: resolve => require(['../view/personView/companyDetail.vue'], resolve),
        },
        {
          path: "account",    // 账号管理页
          name: "account",
          component: resolve => require(['../view/personView/account.vue'], resolve),
        },
        {
          path: "phrases",    // 常用语管理
          name: "phrases",
          component: resolve => require(['../view/personView/phrases.vue'], resolve),
        },
        {
          path: "Feedback",    // 意见反馈
          name: "Feedback",
          component: resolve => require(['../view/personView/Feedback.vue'], resolve),
        },
        {
          path: "myDeliver",     // 沟通过、已投递列表页
          name: "myDeliver",
          component: resolve => require(['../view/personView/myDeliver.vue'], resolve),
        },
        {
          path: "myCollect",     // 我的收藏列表页
          name: "myCollect",
          component: resolve => require(['../view/personView/myCollect.vue'], resolve),
        },
        {
          path: "positionList",     // 职位列表
          name: "positionList",
          component: resolve => require(['../view/personView/positionList.vue'], resolve),
        },
        {
          path: "onlienVitae",     // 个人简历页
          name: "onlienVitae",
          component: resolve => require(['../view/personView/onlienVitae.vue'], resolve),
        },
        {
          path: "wallet",     // 我的GO币页面
          name: "wallet",
          component: resolve => require(['../view/personView/wallet.vue'], resolve),
        },
        {
          path: "personalCenter",     // 个人中心页
          name: "personalCenter",
          component: resolve => require(['../view/personView/personalCenter.vue'], resolve),
        },
        {
          path: "positionDetail",     // 职位详情
          name: "positionDetail",
          component: resolve => require(['../view/personView/positionDetail.vue'], resolve),
        },
        {
          path: "",
          redirect: "index"
        }
      ]
    },
    {
      path: "/mainPrise",    // 企业端页面
      name: "mainPrise",
      component: resolve => require(['../view/mainPrise.vue'], resolve),
      children: [
        {
          path: "staging",     // 工作台
          name: "staging",
          meta: {
            requireAuth: true,
            parentName: 'staging'
          },
          component: resolve => require(['../view/priseView/staging.vue'], resolve),
        },
        {
          path: "purchaseVip",     // 工作台 -> 会员权益
          name: "purchaseVip",
          meta: {
            requireAuth: true,
            parentName: 'staging'
          },
          component: resolve => require(['../view/priseView/purchaseVip.vue'], resolve),
        },
        {
          path: "talent",     // 人才管理
          name: "talent",
          meta: {
            requireAuth: true,
            parentName: 'talent'
          },
          component: resolve => require(['../view/priseView/talent.vue'], resolve),
        },
        {
          path: "pro",     // RPO推荐
          name: "pro",
          meta: {
            requireAuth: true,
            parentName: 'pro'
          },
          component: resolve => require(['../view/priseView/pro.vue'], resolve),
        },
        {
          path: "positionCostom",     // 职位管理
          name: "positionCostom",
          meta: {
            requireAuth: true,
            parentName: 'positionCostom'
          },
          component: resolve => require(['../view/priseView/positionCostom.vue'], resolve),
        },
        {
          path: "delivered",     // 已投递
          name: "delivered",
          meta: {
            requireAuth: true,
            parentName: 'positionCostom'
          },
          component: resolve => require(['../view/priseView/delivered.vue'], resolve),
        },
        {
          path: "videoPage",     // 视频简历列表
          name: "videoPage",
          meta: {
            requireAuth: true,
            parentName: 'positionCostom'
          },
          component: resolve => require(['../view/priseView/videoPage.vue'], resolve),
        },
        {
          path: "phrasesPrise",    // 常用语管理
          name: "phrasesPrise",
          meta: {
            requireAuth: true,
            parentName: 'accountManagement'
          },
          component: resolve => require(['../view/priseView/phrasesPrise.vue'], resolve),
        },
        {
          path: "editPosPage",     // 职位管理->新增、编辑
          name: "editPosPage",
          meta: {
            requireAuth: true,
            parentName: 'positionCostom'
          },
          component: resolve => require(['../view/priseView/editPosPage.vue'], resolve),
        },
        {
          path: "chatMessage",     // 沟通管理
          name: "chatMessage",
          meta: {
            requireAuth: true,
            parentName: 'chatMessage'
          },
          component: resolve => require(['../view/priseView/message/chatMessage.vue'], resolve),
        },
        {
          path: "myCollectP",     // 收藏
          name: "myCollectP",
          meta: {
            requireAuth: true,
            parentName: 'myCollectP'
          },
          component: resolve => require(['../view/priseView/myCollectP.vue'], resolve),
        },
        {
          path: "myWallet",     // 我的GO币
          name: "myWallet",
          meta: {
            requireAuth: true,
            parentName: 'myWallet'
          },
          component: resolve => require(['../view/priseView/myWallet.vue'], resolve),
        },
        {
          path: "companyManagement",     // 企业管理
          name: "companyManagement",
          meta: {
            requireAuth: true,
            parentName: 'companyManagement'
          },
          component: resolve => require(['../view/priseView/companyManagement.vue'], resolve),
        },
        {
          path: "addressList",     // 企业管理 -> 地址列表
          name: "addressList",
          meta: {
            requireAuth: true,
            parentName: 'companyManagement'
          },
          component: resolve => require(['../view/priseView/addressList.vue'], resolve),
        },
        {
          path: "ZPZ",     // 企业管理 -> 招聘者信息
          name: "ZPZ",
          meta: {
            requireAuth: true,
            parentName: 'companyManagement'
          },
          component: resolve => require(['../view/priseView/ZPZ.vue'], resolve),
        },
        {
          path: "team",     // 招聘团队
          name: "team",
          meta: {
            requireAuth: true,
            parentName: 'team'
          },
          component: resolve => require(['../view/priseView/team.vue'], resolve),
        },
        {
          path: "resources",     // 招聘团队 -> 分配资源
          name: "resources",
          meta: {
            requireAuth: true,
            parentName: 'team'
          },
          component: resolve => require(['../view/priseView/resources.vue'], resolve),
        },
        {
          path: "allocationRecords",     // 招聘团队 -> 分配资源 -> 分配记录
          name: "allocationRecords",
          meta: {
            requireAuth: true,
            parentName: 'team'
          },
          component: resolve => require(['../view/priseView/allocationRecords.vue'], resolve),
        },
        {
          path: "examine",     // 招聘团队 -> 审核
          name: "examine",
          meta: {
            requireAuth: true,
            parentName: 'team'
          },
          component: resolve => require(['../view/priseView/examine.vue'], resolve),
        },
        {
          path: "accountManagement",     // 账号管理
          name: "accountManagement",
          meta: {
            requireAuth: true,
            parentName: 'accountManagement'
          },
          component: resolve => require(['../view/priseView/accountManagement.vue'], resolve),
        },
        {
          path: "blackList",     // 黑名单
          name: "blackList",
          meta: {
            requireAuth: true,
            parentName: 'accountManagement'
          },
          component: resolve => require(['../view/priseView/blackList.vue'], resolve),
        },
        {
          path: "recommendedTalents",     // 推荐人才
          name: "recommendedTalents",
          meta: {
            requireAuth: true,
            parentName: 'recommendedTalents'
          },
          component: resolve => require(['../view/priseView/recommendedTalents.vue'], resolve),
        },
        {
          path: "searchTalent",     // 搜索人才
          name: "searchTalent",
          meta: {
            requireAuth: true,
            parentName: 'searchTalent'
          },
          component: resolve => require(['../view/priseView/searchTalent.vue'], resolve),
        },
        {
          path: "",
          redirect: "positionCostom"
        }
      ]
    },
    { path: "*", redirect: (JSON.parse(localStorage.getItem('detailInfo'))||{}).identity=='2' ?"/mainPrise":'/mainPerson' }, // 初始页面配置
    // {path:"*",name: 'Error',component:resolve => require(['../view/Error.vue'],resolve)}
  ]
});

// 路由拦截
router.beforeEach((to, from, next) => {
  if (to.meta.requireAuth) { // 判断该路由是否需要登录权限
    if (window.localStorage.getItem('goToken')) {
      if(window.localStorage.getItem("token_expiration_time") && window.localStorage.getItem("token_expiration_time") > Date.now()){
        next()
     }else{
       Message.warning("请重新登录")
       next({
         path: '/login',
         query: { redirect: to.fullPath }
       })
     }
    } else {
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      })
    }
  } else {
    next()
  }

});
// 请求拦截
axios.interceptors.request.use(
  config => {
    config.headers["Content-type"] = "application/json;charset=UTF-8"
    config.headers.token = window.localStorage.getItem("goToken") || "";
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截
axios.interceptors.response.use(
  response => {
    // console.log(response,"response")
    if (response.data.code == 511) {
      Message.warning("请重新登录")
      window.localStorage.removeItem('goToken');
      router.replace({
        path: '/login',
        query: { redirect: router.currentRoute.fullPath }
      })
      return;
    }
    if (response.data.code == 513) {
      if(window.localStorage.getItem('goToken')){
        Message.warning("请重新认证企业")
        window.localStorage.removeItem('goToken');
      }
      router.replace({
        path: '/login',
        query: { cutType:2,companyAuth:3 }
      })
      return;
    }
    return response
  },
  error => {
    if (error.response) {
      // console.log('error=====', error.response)
    }
  });
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js